import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AboutPage from "@/components/equinox/AboutPage";
import AsoAiEnginePage from "@/components/equinox/AsoAiEnginePage";
import { Toaster } from "sonner";
import CaseStudiesPage from "@/components/equinox/CaseStudiesPage";
import CaseStudyDetailPage from "@/components/equinox/CaseStudyDetailPage";
import ContactPage from "@/components/equinox/ContactPage";
import GivesBackPage from "@/components/equinox/GivesBackPage";
import HomePage from "@/components/equinox/HomePage";
import HowWeScaleAppsPage from "@/components/equinox/HowWeScaleAppsPage";
import InsightsPage from "@/components/equinox/InsightsPage";
import LegalPage from "@/components/equinox/LegalPage";
import LeadsDashboardPage from "@/components/equinox/LeadsDashboardPage";
import LeadTrackerLoginPage from "@/components/equinox/LeadTrackerLoginPage";
import MarketingLayout from "@/components/equinox/MarketingLayout";
import ProtectedLeadRoute from "@/components/equinox/ProtectedLeadRoute";
import ServiceDetailPage from "@/components/equinox/ServiceDetailPage";
import SystemsPage from "@/components/equinox/SystemsPage";

function App() {
  return (
    <div className="App min-h-screen bg-[#05050A] text-white">
      <BrowserRouter>
        <Routes>
          <Route element={<MarketingLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/aso-ai-engine" element={<AsoAiEnginePage />} />
            <Route path="/services" element={<SystemsPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/how-we-scale-apps" element={<HowWeScaleAppsPage />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/case-studies/:slug" element={<CaseStudyDetailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/gives-back" element={<GivesBackPage />} />
            <Route path="/lead-tracker-login" element={<LeadTrackerLoginPage />} />
            <Route path="/leads-dashboard" element={<ProtectedLeadRoute><LeadsDashboardPage /></ProtectedLeadRoute>} />
            <Route path="/legal/:slug" element={<LegalPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        richColors
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(8, 10, 18, 0.96)",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#ffffff",
          },
        }}
      />
    </div>
  );
}

export default App;
